<template>
  <div>

    <div class="unitProductsEmpty">
      <br/>
      <figure class="about-img2 img-wrapper">
        <img src="../assets/static/images/illustrations/metrics1.svg" />
      </figure>
      <h2>{{ $t('obMetrics') }}</h2>               
    </div>

    <div class="activeClient">
      <main>
        <article>
          <h3 class="metricsInitals">NPS</h3>
          <!-- <VueJsCounter class="metricsNo" end="80"></VueJsCounter> -->
          <!-- <span class="metricsUnit">%</span> -->
          <NpsChartClient/>
          <p class="metricsDesc">evaluate long-term customer loyalty and happiness</p>
        </article>

        <article>
          <h3 class="metricsInitals">CSAT</h3>
          <!-- <VueJsCounter class="metricsNo" start="1" end="4.5" decimal="."></VueJsCounter> -->
          <!-- <span class="metricsUnit">%</span> -->
          <CsatChartClient/>
          <p class="metricsDesc">evaluate short-term guest satisfaction</p>
        </article>

        <article>
          <h3 class="metricsInitals">CAR</h3>
          <!-- <VueJsCounter class="metricsNo" start="1" end="51"></VueJsCounter> -->
          <span class="metricsUnit">%</span>
          <CarChartClient/>
          <p class="metricsDesc">evaluate percentage of guests abandon their shopping cart</p>
        </article>

        <article>
          <h3>Top selling products</h3>
        </article>
        <article>
          <h3>Unit sales performance</h3>
        </article>
        <article>
          <h3>Comments from Guests</h3>
        </article>
        <article>7</article>
        <article>8</article>
        <article>9</article>
      </main>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
// import VueJsCounter from 'vue-js-counter'
import NpsChartClient from '@/components/charts/NpsChartClient.vue'
import CsatChartClient from '@/components/charts/CsatChartClient.vue'
import CarChartClient from '@/components/charts/CarChartClient.vue'


// import ProductService from '@/services/ProductService.js'

//import ProductCard from '@/components/ui/ProductCard.vue'
// import UnitCard from '@/components/ui/UnitCard.vue'
//import ProductCategoryCard from '@/components/ui/ProductCategoryCard.vue'

//import { mapState } from 'vuex'

export default {
  components: {
    // VueJsCounter,
    NpsChartClient,
    CsatChartClient,
    CarChartClient
  },
  data() {
    return {
      isLoading: true,
      clientInfo: null,
      loading: true,
      errored: false,
      id: this.client.id  //! sql: "DELETE from clients WHERE id = 'undefined'"
    }
  },
  mounted() {
    axios
      .get(`${process.env.VUE_APP_API_URL}/clients`)
      .then(response => {
        this.clientInfo = response.data
      })
      .catch(error => {
        console.log(error)
        this.errored = true
      })
      .finally(() => (this.loading = false))  },
  methods: {
    deleteClient() {
      if (confirm('are you sure?')) {
        this.$store
          .dispatch('client/removeClient', this.id)
          // .then(() => {
          //   this.$router.push({
          //     path: '/products'
          //   })
          // })
          .catch(e => console.log(e))
      }
    }
  },
  props: {
    client: {
      type: Object,
      default: () => {
        return {}
      }
    }
  }
}
</script>

<style lang="scss" scoped>

* {
  box-sizing: border-box;
}

.unitProductsEmpty {
  display: none; //! none when FIRST unitProduct with this client_id is already found in db //
}
.activeClient {
  // display: none; //! none when NO unitProduct with this client_id is found in db //
}

main {
  max-width: 1200px;
  margin: 30px auto;
  padding: 0 20px;
  width: 100%; 
  display: grid;
  /* Define Auto Row size */
  // grid-auto-rows: 100px; 
  /*Define our columns */
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr)); 
  grid-gap: 1em;
}

article {
  border-radius: 10px;
  padding: 20px;
  color: #fff;
}

.metricsNo {
  font-size: 4em;
  font-weight: 800;
  padding-left: 2px;
  display: inline;
}
.metricsUnit {
  font-size: 1.5em;
}
.metricsInitals {
  font-weight: 400;
  font-size: 2.7em;
  padding-left: 0px;
  letter-spacing: 2px;
}
.metricsDesc {
  font-size: 1em;
}

article:nth-child(1) {
  background-color: var(--primary);
}

article:nth-child(2) {
  background-color: var(--primary);
}
article:nth-child(3) {
  background-color: var(--primary);
}
article:nth-child(4) {
  background-color: var(--bg);
}
article:nth-child(5) {
  background-color: var(--bg);
}
article:nth-child(6) {
  background-color: var(--grey-light);
}

</style>

